import React from "react";
import styles from "./AboutUs.module.css";

const AboutUs = () => {
  return (
    <div className={styles.aboutUsContainer}>
      <h1><center>ABOUT US</center></h1>

      <p className={styles.aboutDesc}>
        <br />
        We are passionate about crafting spaces that bring people together,
        foster authentic self-expression, and cultivate lasting relationships —
        building not just homes, but vibrant communities.
      </p>


      <section className={styles.section}>
        <h2>MISSION STATEMENT</h2>
        <h3>Property Plateau Realty</h3>
        <p>
          At Property Plateau Realty, we are driven by purpose in real estate with
          integrity, innovation, and inclusivity.
          <br />
          Our mission is to empower every buyer, seller, and investor with trusted
          expertise, personalized service, and a seamless experience that goes
          beyond transactions.
          <br />
          We're not just selling properties — we're building dreams, nurturing
          communities, and unlocking new possibilities for ownership and prosperity.
        </p>

        <ul className={styles.missionPoints}>
          <li>Deliver exceptional real estate guidance with heart and honesty</li>
          <li>Grow a vibrant network of lifelong clients by providing lasting value and support</li>
          <li>Make luxury and homeownership accessible to all, across every plateau of life</li>
          <li>Uplift the communities we serve through consistent engagement and contribution</li>
          <li>Ensure every stakeholder feels seen, heard, and empowered in their journey</li>
          <li>Property Plateau is more than a brand — it's a movement to make real estate smarter, fairer, and truly human</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>VISION STATEMENT</h2>
        <h3>Property Plateau Realty</h3>
        <p>
          To be the most trusted name in real estate — delivering unmatched service,
          smart solutions, and lasting value through integrity, innovation, and a
          people-first approach.
          <br />
          We are driven to empower clients, uplift communities, and ensure success
          for all — just a call away, always here to serve.
        </p>
      </section>

      <section className={styles.coreValues}>
        <h2>OUR CORE VALUES</h2>
        <h3>Property Plateau Realty</h3>
        <ul>
          <li>
            <strong>Empower through ownership:</strong> We believe homeownership
            and financial stability are the foundations of personal freedom and
            long-term success.
          </li>
          <li>
            <strong>Innovate with purpose:</strong> We embrace forward-thinking
            strategies and technologies to transform the real estate experience.
          </li>
          <li>
            <strong>Serve exceptionally:</strong> We are committed to delivering
            world-class service with heart.
          </li>
          <li>
            <strong>Grow together:</strong> We invest in the growth of our clients
            and employees.
          </li>
          <li>
            <strong>Excel with integrity:</strong> Excellence isn’t optional —
            it's our standard.
          </li>
        </ul>
      </section>
    </div>
  );
};

export default AboutUs;
